<template>
    <div>

        <b-row :align-h="canGetReport() ? 'between' : 'end'" class="mt-2 mb-4 mx-3">
            <!-- export report -->
            <b-row v-if="canGetReport()">
                <b-col class="info-row-ie-30">
                    <b-row>
                        <b-button @click="$refs.excelTypes.show()" size="lg" ><i class="far fa-file-excel"></i></b-button>
                    </b-row>
                </b-col>
                <b-row style="margin-left:10px; margin-top:15px"> {{$t('exportData')}} </b-row>
                <b-modal ref="excelTypes" size="sm" hide-footer hide-header centered>
                    <b-form-select cols="6" v-model="selectedExcelType" :options="excelTypes" @change="exportExcel($event)"></b-form-select>
                </b-modal>
            </b-row>
            <b-row>
                <!-- year select -->
                <year-select @onchange="onYearChange" style="margin-right: 15px"/>
                <!-- site type select -->
                <site-type-select v-if="siteTypes.length && this.$store.state.user.permissions.isAdmin" style="margin-right: 25px" @onchange="onSiteTypeChange"/>
                <!-- region select -->
                <region-multi-select
                    v-if="this.$store.state.user.permissions.isAdmin"
                    :selectedRegionId="selectedSiteGroupId"
                    :regions="siteGroups"
                    @oninput="selectSiteGroupId"
                    style="margin-right: 15px"
                />
                <!-- site select -->
                <site-multi-select style="margin-right: 15px"
                    v-if="this.$store.state.user.permissions.isAdmin || this.$store.state.user.permissions.canEditGoals || this.$store.state.user.assignedSites.length > 1"
                    :selectedSiteId="selectedSiteId"
                    :givenSites="filteredSites"
                    @oninput="selectSiteId"
                />
            </b-row>
        </b-row>

        <b-row style="height: 125px; background-color: white;" no-gutters>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('siteName') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; margin-left:1px; font-size: 1rem;">
                    {{selectedSite.code}} - {{ selectedSite.originalName }}
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('isOpen') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ (selectedSite.isOpen == 1) ? $t('siteOpen') : $t('siteClosed')  }}
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('cityTitle') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ cityCodeToDisplayName }}
                </b-row>
            </b-col>
            <b-col v-else>
                <b-row class="info-card-site">
                    {{ $t('siteCount') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ filteredSites.length }}
                </b-row>
            </b-col>
            <b-col>
                <b-row class="info-card-site">
                    {{ $t('regionTitle') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ groupDisplayName }}
                </b-row>
            </b-col>
            <b-col>
                <b-row class="info-card-site">
                    {{ $t('number of people') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div>{{ totalStaffCount | parseNumber('number', locale) }}</div>
                </b-row>
            </b-col>
            <b-col>
                <b-row class="info-card-site">
                    {{ $t('areaTitle') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite && selectedSite.yearlyProperties[this.year]">
                        {{ selectedSite.yearlyProperties[this.year].area | parseNumber('number', locale) }}
                        m<sup>2</sup>
                    </div>
                    <div v-else>-</div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t(this.getGroupName('agent')) }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.agents">
                        <span v-for="(agent,index) in selectedSite.agents" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.agentIds[index]}}">{{ agent ? agent : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    <template v-if="this.isbId(this.$store.state.user.customerId)"><span>{{ $t('technician') }}</span></template>
                    <template v-else><span>{{ $t('sub-agent') }}</span></template>
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.subAgents">
                        <span v-for="(subAgent,index) in selectedSite.subAgents" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.subAgentIds[index]}}">{{ subAgent ? subAgent : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t(this.getGroupName('supervisor')) }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.supervisors">
                        <span v-for="(supervisor,index) in selectedSite.supervisors" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.supervisorIds[index]}}">{{ supervisor ? supervisor : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('manager') }}
                </b-row>
                <b-row class="bottom-card-site" align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.directors">
                        <span v-for="(director,index) in selectedSite.directors" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.directorIds[index]}}">{{ director ? director : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
        </b-row>
        <b-row align-h="center" no-gutters style="height: 80px; background-color: white;" v-if="selectedSite">
            <b-col style="text-align: center" class="mt-3">
                <span style="font-weight: bold;">{{$t('address')}}:</span>
                <span>{{ selectedSite.address ? selectedSite.address : '-' }}</span>
                <span style="font-weight: bold; margin-left: 20px">{{$t('phone')}}:</span>
                <span>{{ selectedSite.phone ? selectedSite.phone : '-' }}</span>
            </b-col>
        </b-row>
        <!-- info cards if customerId != 1 !-->
        <div v-if="!this.gbId(this.$store.state.user.customerId)">
            <b-row no-gutters style="margin-top: 1.25rem">
                <b-col cols="3" class="info-card">
                    <b-row no-gutters align-h="around">
                        <b-col cols="11" style="background-color: #decf3f;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col @click="routeToData()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-database" style="color: #decf3f"></i>
                                        </div>
                                    </b-row>
                                    <b-row align-h="center" style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 5px;">
                                        {{ $t('dataTitle') }}
                                    </b-row>
                                </b-col>
                                <!--
                                <b-col @click="routeToData()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('dataHealthRatio') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalDataHealthRatio | localizedRatioText(locale) }}
                                    </b-row>
                                </b-col>
                                -->
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" class="info-card">
                    <b-row no-gutters align-h="around">
                        <b-col cols="11" style="background-color: #6fd088;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-tasks" style="color: #6fd088"></i>
                                        </div>
                                    </b-row>
                                    <b-row align-h="center" style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 5px;">
                                        {{ $t('goalsTitle') }}
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToGoalDetail()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('approvedTitle') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalApprovedGoalCount }}
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToGoalDetail()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('total') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalGoalCount }}
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" class="info-card">
                    <b-row no-gutters align-h="around">
                        <b-col cols="11" style="background-color: #48b1b4;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-copy" style="color: #48b1b4"></i>
                                        </div>
                                    </b-row>
                                    <b-row align-h="center" style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 5px;">
                                        {{ $t('documentsTitle') }}
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('total') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalDocCount }}
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" class="info-card">
                    <b-row no-gutters align-h="around">
                        <b-col cols="11" style="background-color: #ba93a5;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-calendar-check" style="color: #ba93a5"></i>
                                        </div>
                                    </b-row>
                                    <b-row align-h="center" style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 5px;">
                                        {{ $t('auditTitle') }}
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('openedTitle') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalOpenedTicketCount }}
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row align-h="center" style="color: white; margin-top: 10px; font-size: 0.9rem; font-weight: bold;">
                                        {{ $t('total') }}
                                    </b-row>
                                    <b-row align-h="center" class="info-card-value">
                                        {{ totalTicketCount }}
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <!-- Info cards if customerId == 1 -->
        <div v-else>
            <!-- First row of info cards. -->
            <b-row no-gutters style="margin-top: 1.25rem">
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col style="background-color: #DECE3E;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToGoalDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-tasks" style="color: #DECE3E"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToGoalDetail()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 10px; margin-right: 10px">
                                        {{ $t('goalsAndGoalTrackingTitle') }}
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #6FD087;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon" style="margin-right: 30px" >
                                            <i class="fas fa-copy" style="color: #6FD087;"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-right: 20px; height: 2em">
                                        {{ $t('emergencySituationForms') }}
                                    </b-row>
                                </b-col>  
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #6FD087;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-dropdown data-toggle="dropdown" id="ddownWaste" ref="ddownWasteRef" size="sm" style="cursor: pointer; margin-right: 20px" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template slot="button-content"> 
                                            <!-- this b-row should be set to internet explorer size -->
                                            <b-row class="info-row-ie-30">
                                                <b-col class="info-card-icon-dropdown">
                                                    <i class="fas fa-copy" style="color: #6FD087"></i>
                                                </b-col>
                                                <b-col style="cursor: pointer; margin-top: 10px; margin-left: 50px;">
                                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white">
                                                        {{ $t('wasteManagement') }}
                                                    </b-row>
                                                </b-col> 
                                            </b-row>
                                        </template>
                                        <b-dropdown-item @click="routeToFormCreate(1)"> {{$t('wasteTrackingForm')}} </b-dropdown-item>
                                        <b-dropdown-item @click="routeToFormCreate(2)"> {{$t('wasteDeliveryForm')}} </b-dropdown-item>
                                    </b-dropdown>
                                </b-col> 
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #48B1B4;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-list-alt" style="color: #48B1B4"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 10px; margin-right: 40px">
                                        {{ $t('correctiveActionReport') }}
                                    </b-row>
                                </b-col>  
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #BA92A5;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-file" style="color: #BA92A5"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.8rem; font-weight: bold; color: white; margin-top:10px; margin-right:10px">
                                        {{ $t('meetingNotesAndInformationMails') }}
                                    </b-row>
                                </b-col>  
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- Second row of info cards. -->
            <b-row no-gutters style="margin-top: 1.25rem">
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #faa43a;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToData()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-database" style="color: #faa43a"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToData()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 10px; margin-right: 10px;">
                                        {{ $t('sourceDataTitle') }}
                                    </b-row>    
                                </b-col>    
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #6FD087;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-dropdown id="ddownChemical" ref="ddownChemicalRef" size="sm" style="cursor: pointer;" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template slot="button-content"> 
                                            <!-- this b-row should be set to internet explorer size -->
                                            <b-row class="info-row-ie-150">
                                                <b-col class="info-card-icon-dropdown">
                                                    <i class="fas fa-copy" style="color: #6FD087;"></i>
                                                </b-col>
                                                <b-col style="cursor: pointer;">
                                                    <b-row style="font-size: 0.8rem; font-weight: bold; color: white; margin-top: 10px; margin-left:10px">
                                                        {{ $t('chemicalMaterialUsage') }}
                                                    </b-row>
                                                </b-col> 
                                            </b-row>
                                        </template>
                                        <b-dropdown-item @click="routeToFormCreate(3)"> {{$t('chemicalMaterialForm')}} </b-dropdown-item>
                                        <b-dropdown-item @click="routeToDocumentDetail()"> {{$t('chemicalMaterialSdsForm')}} </b-dropdown-item>
                                    </b-dropdown>
                                </b-col> 
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #DB7093;">
                            <b-row style="margin:20px 0" no-gutters>
                                <b-col>
                                    <b-dropdown id="ddownEducation" ref="ddownEducationRef" size="sm" style="cursor: pointer;" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template slot="button-content"> 
                                            <!-- this b-row should be set to internet explorer size -->
                                            <b-row class="info-row-ie-100">
                                                <b-col class="info-card-icon-dropdown">
                                                    <i class="fas fa-file-powerpoint" style="color: #DB7093"></i>
                                                </b-col>
                                                <b-col style="cursor: pointer;">
                                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 10px; margin-left: 30px;">
                                                        {{ $t('educationPresentations') }}
                                                    </b-row>
                                                </b-col> 
                                            </b-row>
                                        </template>
                                        <b-dropdown-item @click="routeToDocumentDetail()"> {{$t('onlineCoursePresentation')}} </b-dropdown-item>
                                        <b-dropdown-item @click="routeToDocumentDetail()"> {{$t('intraclassCoursePresentation')}} </b-dropdown-item>
                                    </b-dropdown>
                                </b-col> 
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #48B1B4;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-list-alt" style="color: #48B1B4"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToAuditDetail()" style="cursor: pointer;">
                                    <b-row style="font-size: 1.0rem; font-weight: bold; color: white; margin-top: 10px; margin-right: 10px;">
                                        {{ $t('actionPlan') }}
                                    </b-row>
                                </b-col>  
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="info-card" style="padding-right: 10px">
                    <b-row no-gutters align-h="around">
                        <b-col  style="background-color: #BA92A5;">
                            <b-row style="margin:25px 0" no-gutters>
                                <b-col @click="routeToDocumentDetail()" style="cursor: pointer;">
                                    <b-row align-h="center">
                                        <div class="info-card-icon">
                                            <i class="fas fa-file" style="color: #BA92A5"></i>
                                        </div>
                                    </b-row>
                                </b-col>
                                <b-col @click="routeToLibrary()" style="cursor: pointer;">
                                    <b-row style="font-size: 0.9rem; font-weight: bold; color: white; margin-top: 10px; margin-right: 10px">
                                        {{ $t('usageGuide') }}
                                    </b-row>
                                </b-col>  
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <b-row no-gutters style="margin-top: 1.25rem">
            <b-col cols="12" xl="12" lg="12" md="12" class="total-carbon-emission-card">
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <b-row align-h="end" no-gutters>
                        <div style="margin: 15px">
                    <span
                        class="card-nav"
                        :style="{color: activeTabs.firstBox === 'carbon' ? '#1c7430' : ''}"
                        @click="activeTabs.firstBox = 'carbon'">
                        {{$t('carbonEmission')}}
                    </span>
                            <span style="margin: 0 5px; color: #1c7430">|</span>
                            <span class="card-nav"
                                :style="{color: activeTabs.firstBox === 'consumption' ? '#1c7430' : ''}"
                                @click="activeTabs.firstBox = 'consumption'">
                        {{$t('carbonConsumption')}}
                    </span>
                        </div>
                    </b-row>
                    <b-row align-h="center" style="margin-top: 30px;">
                        <span style="font-size: 1.1em; font-weight: bold;">{{ $t('carbonEmissionTitle') }}</span>
                    </b-row>
                    <total-carbon-emissions
                        v-if="activeTabs.firstBox === 'carbon'"
                        :initial-emissions="JSON.parse(JSON.stringify(initialEmissions))"
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :group-type="'scopeGroup'"
                        style="margin-top: 30px; min-height: 300px"/>
                    <total-carbon-consumptions v-else
                                            :initial-consumptions="JSON.parse(JSON.stringify(initialConsumptions))"
                                            :selected-site-id="selectedSiteId"
                                            :selected-site-group-id="selectedSiteGroupId"
                                            style="margin-top: 30px; min-height: 300px"/>
                </div>
            </b-col>
        </b-row>
        <b-row no-gutters style="margin-top: 30px; background-color: white;" align-h="center">
            <b-col v-for="(typeId, index) in selectedChartDataTypes" cols="4" :key="index">
                <b-row align-h="center">
                    <b-col cols="12" style="margin: 20px auto;">
                        <bar-chart style="position: relative; height: 300px; width: 95%;" v-if="isLoaded" :chart-data="consumptions[typeId].barChartData" :options="consumptions[typeId].barChartOptions" :chart-id="consumptions[typeId].chartId"/>
                    </b-col>
                    <b-col cols="12" style="font-size: 1em; text-align: center; margin-top:-20px; padding-bottom:20px">{{ consumptions[typeId].title }}</b-col>
                    <b-col cols="12">
                        <b-row no-gutters align-h="center" style="font-size: 12px">
                            <table>
                                <thead>
                                    <td>
                                        <span :style="{'background-color': consumptions[typeId].barChartData.datasets[0].backgroundColor, 'font-weight': 'bold', padding: '2px'}">{{ year - 1 }}</span>
                                    </td>
                                    <td>
                                        <span :style="{'background-color': consumptions[typeId].barChartData.datasets[1].backgroundColor, 'font-weight': 'bold', padding: '2px'}">{{ year }}</span>
                                    </td>
                                    <td>
                                        <b-col  style="text-align: center; font-weight: bold">
                                            <span>{{ $t('changingColumn') }}</span>
                                        </b-col>
                                    </td>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div style="padding: 4px;">
                                                <span>
                                                    {{ consumptions[typeId].barChartData.datasets[0].data.reduce((accumulator, currentValue) => accumulator + currentValue) | parseNumber('float', locale) }}
                                                </span>
                                                <span>
                                                    {{ consumptions[typeId].barChartData.datasets[0].unit }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style="padding: 4px;">
                                                <span>
                                                    {{ consumptions[typeId].barChartData.datasets[1].data.reduce((accumulator, currentValue) => accumulator + currentValue) | parseNumber('float', locale) }}
                                                </span>
                                                <span>
                                                    {{ consumptions[typeId].barChartData.datasets[1].unit }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <b-row no-gutters align-h="around">
                                                <b-col cols="5" style="text-align: right">
                                                    <img v-if="calculateRatio(consumptions[typeId].barChartData.datasets[0].data.reduce((accumulator, currentValue) => accumulator + currentValue), consumptions[typeId].barChartData.datasets[1].data.reduce((accumulator, currentValue) => accumulator + currentValue)) < 0" width="12px" height="12px" src="../../assets/icon/down-round-g.svg"/>
                                                    <img v-else width="12px" height="12px" src="../../assets/icon/up_round_r.svg"/>
                                                </b-col>
                                                <b-col cols="5" style="text-align: left; align-self: center">
                                                    {{ calculateRatio(consumptions[typeId].barChartData.datasets[0].data.reduce((accumulator, currentValue) => accumulator + currentValue), consumptions[typeId].barChartData.datasets[1].data.reduce((accumulator, currentValue) => accumulator + currentValue)) | absoluteNumber | parseNumber('float', locale) }}
                                                </b-col>
                                            </b-row>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash';
import Multiselect from 'vue-multiselect';
import qs from 'qs';
import uuidV4 from 'uuid/v4';
import PieChart from '../../components/charts/PieChart';
import mixins from './mixin';
import BarChart from '../../components/charts/BarChart';
import RegionMultiSelect from '../../components/RegionMultiSelect';
import SiteMultiSelect from '../../components/SiteMultiSelect';
import SiteTypeSelect from '../../components/SiteTypeSelect';
import YearSelect from '../../components/YearSelect';
import TotalCarbonEmissions from '../Analysis/Tabs/components/TotalCarbonEmissions';
import TotalCarbonConsumptions from '../Analysis/Tabs/components/TotalCarbonConsumptions';
import Jquery from 'jquery';

var $ = Jquery;

export default {
    components: {
        TotalCarbonConsumptions,
        TotalCarbonEmissions,
        YearSelect,
        SiteTypeSelect,
        SiteMultiSelect,
        RegionMultiSelect,
        BarChart,
        PieChart,
        Multiselect
    },
    mixins: [mixins],
    name: 'Dashboard',
    data() {
        return {
            activeTabs: {
                firstBox: 'carbon'
            },
            isLoaded: false,
            selectedSiteId: null,
            selectedExcelType: null,
            selectedSiteGroupId: null,
            selectedSiteSubAgent: null,
            selectedSiteSupervisor: null,
            filteredSites: [],
            pieChartId: uuidV4(),
            initialEmissions: {
                current: [],
                past: [],
                emissionTypes: []
            },
            initialConsumptions: {
                currentConsumptions: [],
                pastConsumptions: []
            },
            dataHealths: [],
            emissions: null,
            selectedSiteTypeId: null,
            chartDataTypes: this.$store.state.dashboardDataTypes,
            selectedChartDataTypes: [],
            excelTypes: [
                {
                    value: null,
                    text: this.$t('chooseExcel'),
                    disabled: true
                },
                {
                    value: 1,
                    text: this.$t('monthly')
                },
                {
                    value: 2,
                    text: this.$t('yearly')
                },
                {
                    value: 3,
                    text: this.$t('auditDateReport')
                },
                {
                    value: 4,
                    text: this.$t('goalTracking')
                },
                {
                    value: 5,
                    text: this.$t('auditItemTracking')
                },
                {
                    value: 6,
                    text: this.$t('dataQualityAlerts')
                }
            ]
        };
    },
    methods: {
        exportExcel(value) {
            this.selectedExcelType = undefined;
            this.$refs.excelTypes.hide();
            // if value of dropdown item equals 1 , it is monthly. Otherwise it is yearly export.
                
            this.axios.post('/canRequestReport', {})
                .then(({data}) => {
                    if(data == "Sending report"){

                        if (value == 1) {
                            window.open(
                                `${this.apiURL}/dataExport?year=${this.year}&locale=${
                                    this.$store.state.locale
                                }&token=${this.downloadToken}`
                            );
                        } else if (value == 2) {
                            window.open(
                                `${this.apiURL}/yearlyDataExport?locale=${this.$store.state.locale}&token=${
                                    this.downloadToken
                                }`
                            );
                        } else if (value == 3) {
                            window.open(
                                `${this.apiURL}/auditDateReportExport?locale=${this.$store.state.locale}&year=${
                                    this.year
                                }&token=${this.downloadToken}`
                            );
                        } else if (value == 4) {
                            /*
                            window.open(
                                `${this.apiURL}/goalTrackingExport?locale=${this.$store.state.locale}&year=${
                                    this.year
                                }&token=${this.downloadToken}`
                            );
                            */
                            let insertedItem = {
                                year: this.$store.state.year,
                                locale: this.$store.state.locale
                            };
                            this.$Progress.start();
                            return this.axios.post('/goalTrackingMail', insertedItem)
                            .then(({data}) => {
                                if(data == "Sending goal report mail"){
                                    this.showNotificationModal(this.$t('Goal-report-notification'));
                                }else{
                                    this.showErrorNotification(this.$t('Goal-report-already-requested'));
                                }
                                return this.$Progress.finish();
                            })
                            
                        } else if (value == 5) {
                            window.open(
                                `${this.apiURL}/auditItemTrackingExport?locale=${
                                    this.$store.state.locale
                                }&year=${this.year}&token=${this.downloadToken}`
                            );
                        } else if (value == 6) {
                            /* Download report
                            window.open(
                                `${this.apiURL}/dataQualityAlertsExport?locale=${this.$store.state.locale}&year=${
                                    this.year
                                }&token=${this.downloadToken}`
                            );
                            */
                            // Send report mail
                            let insertedItem = {
                                year: this.$store.state.year,
                                locale: this.$store.state.locale
                            };
                            this.$Progress.start();
                            return this.axios.post('/dataQualityAlertsMail', insertedItem)
                            .then(({data}) => {
                                if(data == "Sending quality alert report mail"){
                                    this.showNotificationModal(this.$t('Quality-alert-report-notification'));
                                }else{
                                    this.showErrorNotification(this.$t('Quality-alert-report-already-requested'));
                                }
                                return this.$Progress.finish();
                            })
                            
                        }

                    }else{
                        this.showErrorNotification(this.$t('Already-requested'));
                    }
                    return this.$Progress.finish();
                })
                .catch(() => {
                    this.showErrorNotification(this.$t('Unknown error'));
                });

        },
        showFormDropDown() {
            $(document).ready(function() {
                $('.dropdown').addClass('open');
            });
        },
        filterConsumptions(consumptions) {
            consumptions.currentConsumptions = _.filter(consumptions.currentConsumptions, function(
                o
            ) {
                return o.type !== 'atm';
            });
            consumptions.pastConsumptions = _.filter(consumptions.pastConsumptions, function(o) {
                return o.type !== 'atm';
            });
        },
        selectSiteGroupId(value) {
            if (value) {
                this.filteredSites = this.sites.filter(site => {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.selectSiteId(null);
        },
        selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.routeToDashboard(this.selectedSiteId, this.year);
            this.init();
        },
        routeToDocumentDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'site-files',
                    params: {site_id: this.selectedSiteId},
                    query: {year: this.year}
                });
            } else {
                this.$router.push({
                    name: 'doc',
                    query: {year: this.year}
                });
            }
            return Promise.resolve();
        },
        routeToData() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'site-data-types',
                    params: {site_id: this.selectedSiteId},
                    query: {
                        type: 'consumption',
                        year: this.year
                    }
                });
            } else {
                this.$router.push({name: 'data-sites'});
            }
            return Promise.resolve();
        },
        routeToGoalDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'goal-detail',
                    params: {site_id: this.selectedSiteId}
                });
            } else {
                this.$router.push({
                    name: 'goal',
                    query: {year: this.year}
                });
            }
            return Promise.resolve();
        },
        routeToFormCreate(id) {
            if (this.selectedSiteId) {
                if (id && this.$store.state.user.permissions.canEditData) {
                    this.$router.push({
                        name: 'form-create',
                        params: {site_id: this.selectedSiteId, form_type: id}
                    });
                } else {
                    this.$router.push({
                        name: 'site-forms',
                        params: {site_id: this.selectedSiteId}
                    });
                }
            } else {
                this.$router.push({
                    name: 'forms'
                });
            }
            return Promise.resolve();
        },
        routeToAuditDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'ticket-list',
                    params: {site_id: this.selectedSiteId},
                    query: {start_date: this.year}
                });
            } else {
                this.$router.push({
                    name: 'audit',
                    query: {year: this.year}
                });
            }
            return Promise.resolve();
        },
        routeToLibrary() {
            this.$router.push({
                name: 'library'
            });
            return Promise.resolve();
        },
        retrieveEmissions() {
            let query = {
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1
            };

            if (this.selectedSiteId) {
                query['siteId'] = this.selectedSiteId;
            } else if (this.selectedSiteGroupId) {
                query['groupId'] = this.selectedSiteGroupId;
            }

            return this.axios.get(`/report/emission?${qs.stringify(query)}`).then(({data}) => {
                this.initialEmissions = data;
                return data;
            });
        },
        retrieveConsumptions(year, site_id, site_group_id, source_types) {
            return this.axios
                .get(
                    `/report/consumptions?${qs.stringify(
                        {
                            year,
                            site_id,
                            site_group_id,
                            source_types
                        },
                        {
                            skipNulls: true
                        }
                    )}`
                )
                .then(({data}) => {
                    return data;
                });
        },
        retrieveEmissionConsumptions() {
            let query = {
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1
            };
            if (this.selectedSiteId) {
                query['siteId'] = this.selectedSiteId;
            } else if (this.selectedSiteGroupId) {
                query['groupId'] = this.selectedSiteGroupId;
            }
            return this.axios.get(`/report/consumption?${qs.stringify(query)}`).then(({data}) => {
                this.initialConsumptions = data;
                this.filterConsumptions(this.initialConsumptions);
                return data;
            });
        },
        calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            let subtraction = currentValue - lastValue;
            let ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.routeToDashboard(this.selectedSiteId, this.year);
            this.init();
        },
        onSiteTypeChange(siteTypeId) {
            this.selectedSiteId = null;
            this.selectedSiteGroupId = null;
            if (siteTypeId) {
                this.filteredSites = this.sites.filter(site => {
                    return site.typeId === siteTypeId;
                });
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        retrieveDataHealths() {
            return this.axios
                .get(
                    `/health?${qs.stringify({
                        year: this.year
                    })}`
                )
                .then(({data}) => {
                    this.dataHealths = data;
                    return data;
                });
        },
        init() {
            this.$Progress.start();
            if (this.selectedSiteId) {
                /*
                let site_id = this.selectedSiteId;
                let subAgent_id = _.first(this.selectedSite.subAgentIds);
                this.selectedSiteSubAgent = _.first(_.filter(this.$store.state.agentList, function(o){
                    return o.site_id == site_id && o.id == subAgent_id;
                }));
                // @todo: like supervisor other user types should use first and last names
                // In order to use them backend send supervisorList and directorList,
                let agent_id = _.first(this.selectedSite.agentList);
                let director_id = _.first(this.selectedSite.directorIds);
                let supervisor_id = _.first(this.selectedSite.supervisorIds);                
                this.selectedSiteAgent = _.first(_.filter(this.$store.state.agentList, function(o){
                    return o.site_id == site_id && o.id == _.first(this.selectedSite.agentIds);
                }));
                this.selectedSupervisor = _.first(_.filter(this.$store.state.supervisorList, function(o){
                    return o.site_id == site_id && o.id == _.first(this.selectedSite.supervisorIds);
                }));
                this.selectedDirector = _.first(_.filter(this.$store.state.directorList, function(o){
                    return o.site_id == site_id && o.id == director_id;
                }));
                */
            }
            return Promise.all([
                this.retrieveEmissions(),
                this.retrieveEmissionConsumptions(),
                this.fetchAndConfigureConsumptions(),
                this.$store.dispatch('getDocumentCounts', this.year),
                this.$store.dispatch('getGoalCounts', this.year),
                this.$store.dispatch('getAuditCounts', this.year),
                this.retrieveDataHealths()
            ]).then(() => {
                this.$Progress.finish();
            });
        },
        prepareConsumptionChartData() {
            let _consumptions = _.cloneDeep(this.consumptions);
            this.chartDataTypes.forEach(typeId => {
                _consumptions[typeId].barChartData.datasets[0].data = _consumptions[
                    typeId
                ].barChartData.datasets[0].data.map(() => 0);
                _consumptions[typeId].barChartData.datasets[1].data = _consumptions[
                    typeId
                ].barChartData.datasets[1].data.map(() => 0);
                _consumptions[typeId].current.forEach(consumption => {
                    _consumptions[typeId].barChartData.datasets[1].data[
                        Number(consumption.date) - 1
                    ] += Number(consumption.value.toFixed(2));
                });
                _consumptions[typeId].previous.forEach(consumption => {
                    _consumptions[typeId].barChartData.datasets[0].data[
                        Number(consumption.date) - 1
                    ] += Number(consumption.value.toFixed(2));
                });
                let max = _.max([
                    ..._consumptions[typeId].barChartData.datasets[1].data,
                    ..._consumptions[typeId].barChartData.datasets[0].data
                ]);
                let digitLength = max.toString().split('.')[0].length;
                let maxVal =
                    _.round(max, -1 * (digitLength - 1)) +
                    Number(`1${'0'.repeat(digitLength - 1)}`);
                
                _consumptions[typeId].barChartOptions.scales.yAxes[0].ticks.stepSize = maxVal/10;
            });
            this.consumptions = _consumptions;
            this.chartDataTypes.forEach(typeId => {
                this.$eventHub.$emit(this.consumptions[typeId].chartId);
            });
        },
        fetchAndConfigureConsumptions() {
            this.isLoaded = false;
            return this.retrieveConsumptions(
                this.year,
                this.selectedSiteId,
                this.selectedSiteGroupId,
                this.chartDataTypes
            )
            .then(current => {
                this.selectedChartDataTypes = _.cloneDeep(this.chartDataTypes);
                return this.retrieveConsumptions(
                    this.year - 1,
                    this.selectedSiteId,
                    this.selectedSiteGroupId,
                    this.chartDataTypes
                ).then(previous => {
                    this.chartDataTypes.forEach(typeId => {
                        this.consumptions[typeId].current = current.filter(consumption => {
                        return consumption.dataType === typeId;
                    });
                        this.consumptions[typeId].previous = previous.filter(consumption => {
                            return consumption.dataType === typeId;
                        });
                    });
                    return {current, previous};
                });
            })
            .then(()=>{
                this.prepareConsumptionChartData();
                this.isLoaded = true;
            });
        },
        setReportTypes(){
            if(this.gbId(this.$store.state.user.customerId)){
                this.excelTypes= [
                    {
                        value: null,
                        text: this.$t('chooseExcel'),
                        disabled: true
                    },
                    {
                        value: 1,
                        text: this.$t('monthly')
                    },
                    {
                        value: 2,
                        text: this.$t('yearly')
                    },
                    {
                        value: 3,
                        text: this.$t('auditDateReport')
                    },
                    {
                        value: 4,
                        text: this.$t('goalTracking')
                    },
                    {
                        value: 5,
                        text: this.$t('auditItemTracking')
                    }
                ]
            }
        }
    },
    computed: {
        selectedSiteGroup() {
            let found = _.find(this.siteGroups, {id: this.selectedSiteGroupId});
            if (found) {
                found = JSON.parse(JSON.stringify(found));
                found.display_name = found.display_name.substr(0, 8) + '...';
            }
            return found;
        },
        totalOpenedTicketCount() {
            let found = _.find(this.audits, {siteId: this.selectedSiteId});
            if (found) {
                return found.openedAuditCount;
            } else {
                let total = 0;
                this.audits.forEach(audit => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: audit.siteId});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += audit.openedAuditCount;
                        }
                    } else {
                        total += audit.openedAuditCount;
                    }
                });
                return total;
            }
        },
        totalTicketCount() {
            let found = _.find(this.audits, {siteId: this.selectedSiteId});
            if (found) {
                return found.totalAuditCount;
            } else {
                let total = 0;
                this.audits.forEach(audit => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: audit.siteId});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += audit.totalAuditCount;
                        }
                    } else {
                        total += audit.totalAuditCount;
                    }
                });
                return total;
            }
        },
        totalDocCount() {
            let found = _.find(this.documents, {site_id: this.selectedSiteId});
            if (found) {
                return found.count;
            } else {
                let total = 0;
                this.documents.forEach(document => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: document.site_id});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += document.count;
                        }
                    } else {
                        total += document.count;
                    }
                });
                return total;
            }
        },
        totalApprovedGoalCount() {
            let found = _.find(this.$store.state.goals, {site_id: this.selectedSiteId});
            if (found) {
                return found.approved_count;
            } else {
                let total = 0;
                this.$store.state.goals.forEach(goal => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: goal.site_id});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += goal.approved_count;
                        }
                    } else {
                        total += goal.approved_count;
                    }
                });
                return total;
            }
        },
        totalDataHealthRatio() {
            let found = _.find(this.dataHealths, {siteId: this.selectedSiteId});
            if (found) {
                return found.health;
            } else {
                let total = 0;
                let count = 0;
                this.dataHealths.forEach(site => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: site.siteId});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += site.health;
                            count++;
                        }
                    } else {
                        total += site.health;
                        count++;
                    }
                });
                return count ? Number((total / count).toFixed(2)) : 0;
            }
        },
        totalGoalCount() {
            let found = _.find(this.$store.state.goals, {site_id: this.selectedSiteId});
            if (found) {
                return found.count;
            } else {
                let total = 0;
                this.$store.state.goals.forEach(goal => {
                    if (this.selectedSiteGroupId) {
                        let found = _.find(this.sites, {id: goal.site_id});
                        if (found.siteGroupId === this.selectedSiteGroupId) {
                            total += goal.count;
                        }
                    } else {
                        total += goal.count;
                    }
                });
                return total;
            }
        },
        cityCodeToDisplayName() {
            let found = _.find(this.$store.state.cities, {code: this.selectedSite.cityCode});
            if (found) {
                return found.name;
            } else {
                return '-';
            }
        },
        groupDisplayName() {
            if (this.selectedSite) {
                let found = _.find(this.$store.state.siteGroups, {
                    id: this.selectedSite.siteGroupId
                });
                return found.display_name;
            } else if (this.selectedSiteGroupId) {
                let found = _.find(this.$store.state.siteGroups, {
                    id: this.selectedSiteGroupId
                });
                return found.display_name;
            } else {
                return this.$t('allRegions');
            }
        },
        totalStaffCount() {
            if (this.selectedSiteId) {
                let property = this.getLastFilledProperty(this.selectedSite, 'staffCount');
                return property && property.staffCount ? property.staffCount : '-';
            } else {
                let total = 0;
                this.filteredSites.forEach(site => {
                    if (
                        site.yearlyProperties[this.year] &&
                        site.yearlyProperties[this.year].staffCount
                    ) {
                        total += site.yearlyProperties[this.year].staffCount;
                    } else {
                        let property = this.getLastFilledProperty(site, 'staffCount');
                        let count = property && property.staffCount ? property.staffCount : 0;
                        total += count;
                    }
                });

                return total;
            }
        },
        totalArea() {
            if (this.selectedSiteId) {
                let property = this.getLastFilledProperty(this.selectedSite, 'area');
                return property && property.area ? property.area : '-';
            } else {
                let total = 0;
                this.filteredSites.forEach(site => {
                    if (site.yearlyProperties[this.year] && site.yearlyProperties[this.year].area) {
                        total += site.yearlyProperties[this.year].area;
                    } else {
                        let property = this.getLastFilledProperty(site, 'area');
                        total += property && property.area ? property.area : 0;
                    }
                });
                return total.toFixed(0);
            }
        },
        selectedSite() {
            let found = _.find(this.sites, {id: this.selectedSiteId});
            if (found) {
                found = JSON.parse(JSON.stringify(found));
                found.name = found.name.substr(0, 8) + '...';
            }
            return found;
        },
        hasAnyCarbonEmission() {
            return this.emissions && Object.keys(this.emissions).length;
        }
    },
    watch: {
        'route.query.site_id': function() {
            this.fetchAndConfigureConsumptions();
        },
        selectedSiteGroupId() {
            this.retrieveEmissions();
            this.retrieveEmissionConsumptions();
            this.fetchAndConfigureConsumptions();
        },
        year: function() {
            // Update date in chart
            for (var attributename in this.consumptions) {
                this.consumptions[attributename].barChartData.datasets[0].label = this.year - 1;
                this.consumptions[attributename].barChartData.datasets[1].label = this.year;
            }
        }
    },
    created() {
        let siteId = Number(this.route.query.site_id);
        this.downloadToken = this.token.substr(7);
        this.selectedSiteId = siteId ? siteId : null;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        // if an agent logged in, since there is one site, both state.siteId and selectedSite will be that site.
        _.size(this.filteredSites) == 1 &&
            ((this.selectedSiteId = _.first(this.filteredSites).id) &&
                (this.$store.state.siteId = _.first(this.filteredSites).id));
        this.generateBarChartOptions();
        this.setReportTypes();
        this.init();

    }
};
</script>

<style lang="scss" scoped>
.info-card-site {
    color: #707070;
    font-weight: bold;
    font-size: 1rem;
    height: 50%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-left: 10px;
    margin-right: 10px;
}

.bottom-card-site{
    margin-left: 0;
    margin-right: 0;
}

.info-card-value {
    color: white;
    font-weight: bold;
    font-size: 1.25rem;
    cursor: pointer;
    margin-top: 10px;
}
.info-card-icon {
    width: 45px;
    height: 45px;
    display: inline-block;
    line-height: 45px;
    text-align: center;
    font-size: 20px;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    background-color: #f8f9fa;
}
.info-card-icon-dropdown {
    width: 45px;
    height: 45px;
    display: inline-block;
    line-height: 45px;
    text-align: center;
    font-size: 20px;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    background-color: #f8f9fa;
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        padding-right: 30px;
    }
}

.total-carbon-emission-card {
    background-color: white;
    .total-carbon-emission-pie-chart-size {
        @media (min-width: 1200px) {
            width: 22em;
            height: 22em;
            margin: auto;
        }
    }
}

.card-nav {
    cursor: pointer;
    &:hover {
        color: #1c7430;
    }
}
// custom IE 11 css for dashboard boxes that include dropdown
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .info-row-ie-150 {
        padding-right: 150px;
    }
    .info-row-ie-100 {
        padding-right: 100px;
    }
    .info-row-ie-30 {
        padding-right: 30px;
    }
}
</style>

<i18n src="../../i18n/common.json"></i18n>
<i18n src="../../i18n/carbonEmissionTable.json"></i18n>

<i18n>
    {
        "tr": {
            "consumptions": "Tüketimleri",
            "siteCount": "Lokasyon Sayısı",
            "goalsTitle": "HEDEFLER",
            "goalsAndGoalTrackingTitle": "Hedefler ve Hedef Takip",
            "approvedTitle": "Onaylanmış",
            "documentsTitle": "BELGELER",
            "dataHealthRatio": "Sağlık",
            "dataTitle": "VERİLER",
            "sourceDataTitle": "Kaynak Tüketimleri",
            "auditTitle": "DENETİM",
            "openedTitle": "Açılan",
            "changingColumn": "Değişim (%)",
            "wasteManagement": "Atık Yönetimi",
            "wasteTrackingForm": "Atık Takip Formu",
            "wasteDeliveryForm": "Sıfır Atık Çizelgesi",
            "chemicalMaterialUsage": "Kimyasal Malzeme Kullanımı",
            "chemicalMaterialForm": "Kimyasal Malzeme Formu",
            "chemicalMaterialSdsForm": "Kimyasal Malzeme SDS Formları",
            "emergencySituationForms": "Acil Duruma Hazır Olma ve Müdahale",
            "meetingNotesAndInformationMails": "Toplantı Tutanakları ve Bilgilendirme Mailleri",
            "onlineCoursePresentation": "Sanal Eğitim Sunumu",
            "intraclassCoursePresentation": "Sınıf içi Eğitim Sunumu",
            "correctiveActionReport": "Uygunluğun Değerlendirilmesi",
            "actionPlan": "Aksiyon Planı",
            "educationPresentations": "Eğitim Sunumları",
            "usageGuide":"Kullanım Kılavuzu",
            "siteName":"Lokasyon",
            "number of people": "Kişi Sayısı",
            "monthly": "Aylık Rapor",
            "yearly": "Yıllık Rapor",
            "auditDateReport": "Denetim Tarihi Raporu",
            "goalTracking": "Hedef Takip",
            "auditItemTracking": "Denetim Madde Takibi",
            "dataQualityAlerts": "Veri Sağlığı Uyarıları",
            "chooseExcel": "Lütfen indirmek için bir rapor seçin",
            "exportData": "Tüm veriyi aktar",
            "siteClosed": "Kapalı",
            "Goal-report-notification": "Hedef raporu mail olarak gönderilecektir. Bu işlem biraz zaman alabilir.",
            "Goal-report-already-requested": "Hedef raporu zaten bir kere talep edildi. Lütfen Bekleyin.",
            "Quality-alert-report-notification": "Veri sağlığı uyarı raporu mail olarak gönderilecektir. Bu işlem biraz zaman alabilir.",
            "Quality-alert-report-already-requested": "Veri sağlığı uyarı raporu zaten bir kere talep edildi. Lütfen Bekleyin.",
            "Already-requested": "Daha önceden talep ettiğiniz raporunuz hazırlanıyor. İşlem bittiğinde yeni rapor oluşturmayı deneyebilirsiniz."
        },
        "en": {
            "consumptions": "Consumptions",
            "siteCount": "Sites",
            "areaTitle": "Area",
            "agent": "Agent",
            "sub-agent":"Sub-Agent",
            "supervisor":"Supervisor",
            "manager": "Manager",
            "goalsTitle": "GOALS",
            "goalsAndGoalTrackingTitle": "Goals and Goal Tracking",
            "approvedTitle": "Approved",
            "documentsTitle": "DOCUMENTS",
            "dataHealthRatio": "Health",
            "dataTitle": "DATA",
            "sourceDataTitle": "Consumption of Sources",
            "auditTitle": "AUDITS",
            "openedTitle": "Opened",
            "changingColumn": "Change (%)",
            "wasteManagement": "Waste Management",
            "wasteTrackingForm": "Waste Tracking Form",
            "wasteDeliveryForm": "Zero Waste Table",
            "chemicalMaterialUsage": "Chemical Management",
            "chemicalMaterialForm": "Chemical Material Form",
            "chemicalMaterialSdsForm": "Chemical SDS Material Forms",
            "emergencySituationForms": "Emergency Preparedness and Response Plan",
            "meetingNotesAndInformationMails": "Meeting Notes And Information",
            "onlineCoursePresentation": "Online Course Presentation",
            "intraclassCoursePresentation": "Intraclass Course Presentation",
            "correctiveActionReport": "Corrective Action Report",
            "actionPlan": "Preventive Action Plan",
            "educationPresentations": "Education Presentations",
            "usageGuide":"User Guide",
            "siteName":"Site Name",
            "number of people": "Occupancy",
            "monthly": "Monthly Report",
            "yearly": "Yearly Report",
            "auditDateReport": "Audit Date Report",
            "goalTracking": "Goal Tracking",
            "auditItemTracking": "Audit Item Tracking",
            "dataQualityAlerts": "Data Quality Alerts",
            "chooseExcel": "Please choose a report to download",
            "exportData": "Export data",
            "siteClosed": "Closed",
            "Goal-report-notification": "The target report will be sent by e-mail. This process may take some time.",
            "Goal-report-already-requested": "Goal report has already been requested once. Please wait.",
            "Quality-alert-report-notification": "The data quality alerts report will be sent by e-mail. This process may take some time.",
            "Quality-alert-report-already-requested": "Data quality alerts report has already been requested once. Please wait.",
            "Already-requested": "Your requested report is being prepared. When your report is ready, you can try to create a new report"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue